import React from 'react';
import { ContainerGlobal } from './style';

const WrapperUI: React.FC = ({ children }) => {
  return <ContainerGlobal>{children}</ContainerGlobal>;
};

export default WrapperUI;
